<template>
    <f7-page name="Offline">
        <f7-navbar>
            <f7-nav-left />
            <f7-nav-title />
            <f7-nav-right />
        </f7-navbar>
        <f7-block>
            <div style="margin-top: 120px; font-size: 24px; font-weight: bold">Offline</div>
        </f7-block>
        <f7-block>
            <br><br>
            Coral does not work offline yet<br>but we are working on it!
        </f7-block>

    </f7-page>
</template>

<script>
export default {
    store: ['api'],
    data () {
        return {
        }
    },
    computed: {
        pgap: function () {
            return window.pgap;
        }
    },
    created: function () {
    },
    mounted: function () {

    },
    methods: {

    },
}
</script>

<style lang="less" scoped>
    @import "../css/app.less";
</style>
